import ApiClient from '../../client';

// Per-sponsor cache of published, future, available slots. Resets each time a new
// sponsorId is loaded so stale data from a previous sponsor's modal doesn't leak.

export const state = () => ({
  items: [],
  sponsorId: null,
  loading: false,
  error: null
});

export const getters = {
  getItems: (state) => state.items,
  isLoading: (state) => state.loading,
  failed: (state) => !!state.error
};

export const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
  setItems(state, { items, sponsorId }) {
    state.items = items || [];
    state.sponsorId = sponsorId;
  },
  clear(state) {
    state.items = [];
    state.sponsorId = null;
    state.error = null;
  }
};

export const actions = {
  async fetchForSponsor({ commit }, sponsorId) {
    if (!sponsorId) return;
    commit('setLoading', true);
    commit('setError', null);
    try {
      const response = await ApiClient.getAvailableSlots(sponsorId);
      commit('setItems', { items: response.data || [], sponsorId });
    } catch (err) {
      commit('setError', err);
      commit('setItems', { items: [], sponsorId });
    } finally {
      commit('setLoading', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
